<template>
  <div>
    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'Draft' : ''">
        <div class="lists-view-tab">
          <venue-campaign-list
            title="Draft campaigns"
            description="Draft campaigns are campaigns that have not been submitted for approval yet."
            source="draftCampaigns"
            :showCreateNewButton="true"
          />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-activity" :label="!isSmallerScreen ? 'Pending' : ''">
        <div class="lists-view-tab">
          <venue-campaign-list
            title="Pending campaigns"
            description="Pending campaigns are campaigns that have been submitted for approval but have not been approved yet. If they are rejected, they will show up as rejected here."
            source="pendingCampaigns"
          />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-clock" :label="!isSmallerScreen ? 'Planned' : ''">
        <div class="lists-view-tab">
          <venue-campaign-list
            title="Planned campaigns"
            description="Planned campaigns are campaigns that have been approved and are scheduled to be sent."
            source="plannedCampaigns"
          />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-check-circle" :label="!isSmallerScreen ? 'Completed' : ''">
        <div class="lists-view-tab">
          <venue-campaign-list
            title="Completed campaigns"
            description="Completed campaigns are campaigns that have been approved and have been sent."
            source="completedCampaigns"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import VenueCampaignList from "./VenueCampaignList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    VenueCampaignList,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "users/userId",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
